import { render } from "./HighlightedBlogPosts.vue?vue&type=template&id=58981cc0&scoped=true"
import script from "./HighlightedBlogPosts.vue?vue&type=script&lang=js"
export * from "./HighlightedBlogPosts.vue?vue&type=script&lang=js"

import "./HighlightedBlogPosts.vue?vue&type=style&index=0&id=58981cc0&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58981cc0"]])

export default __exports__